import store from "../../../store";
import { conditionFormChecker, putField } from "../../../utils/form";
import {
    createFieldAcceptCondition,
    createFieldRegister1,
    createFieldRegisterOfficerInfo,
    createFieldRegisterUserInfo,
    createFieldUsernamePassword
} from "../register/register.section";
import lodash from "lodash";
import { Divider } from "ant-design-vue";
import { defineAsyncComponent } from "vue";

const AttachmentInlineList = defineAsyncComponent(() => import("../../../components/attachment/AttachmentInlineList"));

export const callRegisterOfficerAttachment = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "REGISTER_OFFICER_ATTACHMENT", value: searchQuery });

export const createColumns = () => {
    const columns = [];
    return columns;
};

export const createField = ({ props, data, key, isLoading }) => {
    const { viewOnly, menuContext } = props;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            ...createFieldRegister1({ props, data, key, isLoading }),
            ...createFieldRegisterOfficerInfo({ props, data, key, isLoading }),
            ...createFieldRegisterUserInfo({ props, data, key, isLoading }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}attachments`,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "AttachmentInlineList" } })
                    );
                    return <AttachmentInlineList {...componentProp}></AttachmentInlineList>;
                }
            },
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <Divider></Divider>
            },
            ...createFieldUsernamePassword({ props, data, key, isLoading }),
            ...createFieldAcceptCondition({ props, data, key, isLoading })
        ]
    });
};
